import { EGerdauService } from '../EGerdauService';
import {
  customersAuthorizationApi,
  ECustomerAuthorizationEndpoints
} from '../api';
import { IConstructionRegistrationState } from '../../store/ducks/contracts-and-constructions/types';
import {
  EFabricationContractsStatus,
  EWeekDays,
  IFabricationContract
} from '../../store/ducks/fabrication-contracts/types';
import { ECustomerTypeView } from '../../store/ducks/user/types';

export class ContractsAndConstructionsService extends EGerdauService {
  async sendConstructionRegistration(
    constructionRegistration: IConstructionRegistrationState
  ): Promise<void> {
    const headers = super.getHeaders();

    const { contractNumber, deliveryConditions, responsiblesOfConstruction } =
      constructionRegistration;

    const bodyRequest = {
      contractNumber,
      vehicleType: deliveryConditions?.allowedVehicleTypes,
      dischargeType: deliveryConditions?.allowedDischargeType,
      dischargeObservation: deliveryConditions?.dischargeObservation,

      towerOption:
        constructionRegistration.constructionData?.address.towerOption,
      towers: constructionRegistration.constructionData?.address.towers,

      schedules: deliveryConditions?.allowedDaysAndTimeToReceive
        .filter(
          (dayAndTime) =>
            dayAndTime.checked && dayAndTime.startTime && dayAndTime.endTime
        )
        .map((dayAndTime) => {
          return {
            day: dayAndTime.day,
            startTime: dayAndTime.startTime,
            endTime: dayAndTime.endTime
          };
        }),

      responsiblesOfConstruction
    };

    await customersAuthorizationApi.put(
      ECustomerAuthorizationEndpoints.SEND_CONSTRUCTION_REGISTRATION,
      { ...bodyRequest },
      { headers }
    );
  }

  async getCustomerContracts(
    selectedCustomerId: string,
    customerViewType: ECustomerTypeView
  ): Promise<IFabricationContract[]> {
    const headers = super.getHeaders();

    const customerType =
      customerViewType === ECustomerTypeView.EMITTER
        ? customerViewType
        : ECustomerTypeView.RECEIVER;
    const customerContractsResponse = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.CONTRACTS_V2}?customerId=${selectedCustomerId}&customerType=${customerType}`,
      { headers }
    );

    const contractsItems = customerContractsResponse.data
      .items as IFabricationContract[];

    contractsItems.forEach((item) =>
      item.logistic?.schedules.forEach(
        (dayAndTime) =>
          (dayAndTime.day = dayAndTime.day.toString() as EWeekDays)
      )
    );

    this.sortCustomerContracts(contractsItems);

    return contractsItems;
  }

  async getCustomerContractsV2(
    selectedCustomerId: string
  ): Promise<IFabricationContract[]> {
    const headers = super.getHeaders();

    const customerContractsResponse = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.CONTRACTS_V2}?customerId=${selectedCustomerId}`,
      { headers }
    );

    const contractsItems = customerContractsResponse.data
      .items as IFabricationContract[];

    contractsItems.forEach((item) =>
      item.logistic?.schedules.forEach(
        (dayAndTime) =>
          (dayAndTime.day = dayAndTime.day.toString() as EWeekDays)
      )
    );

    this.sortCustomerContracts(contractsItems);

    return contractsItems;
  }

  private sortCustomerContracts(customerContracts: IFabricationContract[]) {
    const orderContractsByStatus = (status: EFabricationContractsStatus) => {
      return customerContracts.sort((a, b) => {
        return a.status === status && b.status !== status
          ? -1
          : a.status !== status && b.status === status
          ? 1
          : 0;
      });
    };

    orderContractsByStatus(EFabricationContractsStatus.OPEN);
    orderContractsByStatus(EFabricationContractsStatus.NEW_CONTRACT);
  }
}
